/**
 * Statuses with nothing left to do. Values must match `REPAIR_ORDER_STATUS` on the
 * backend (warp_portal/apps/repair_orders/constants.py). Internal (WARP-957) is terminal
 * like the others, so it lists with them.
 */
export const RESOLVED_STATUSES = ['Paid', 'Written Off', 'Paid with Adjustments', 'Internal']

/**
 * Status transitions offered by SetStatusModal for ROs that don't yet have an
 * Outstanding List record (i.e. in the Intake → OL path).
 */
export const INTAKE_TRANSITIONS = [
  { value: 'On Outstanding List', label: 'On Outstanding List' },
  { value: 'Closed', label: 'Closed' },
  { value: 'Closed — Submitted', label: 'Closed — Submitted' },
]

/**
 * Status transitions offered by SetStatusModal when an RO is Closed and a WPC user is logging the
 * outcome.
 */
export const CLOSED_TRANSITIONS = [
  { value: 'Paid', label: 'Paid' },
  { value: 'Paid with Adjustments', label: 'Paid with Adjustments' },
]

/**
 * File types accepted by the RO attachment inputs (Manage Repair Order, Log ROs, and the
 * Ready Queue).
 */
export const ACCEPTED_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
]
